export default __webpack_public_path__ + "static/media/level-1-bg.225492eb.png";